import baseAPI from '@/api/base';
import { EditEmployeePosition, GetEmployeePosition, RegisterEmployeePosition } from '@/dtos/employee_position.dto';
import {
  DELETE_EMPLOYEE_POSITION_URL,
  EDIT_EMPLOYEE_POSITION_URL,
  GET_EMPLOYEE_POSITION_URL,
  REGISTER_EMPLOYEE_POSITION_URL,
  TOGGLE_EMPLOYEE_POSITION_IS_ACTIVE_URL,
  GET_UNASSIGNED_EMPLOYEES_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class EmployeePosition {
  static getEmployeePositions = async (getEmployeePosition: GetEmployeePosition): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_EMPLOYEE_POSITION_URL, {
      params: getEmployeePosition,
    });
    return response;
  };

  static registerEmployeePosition = async (
    registerEmployeePosition: RegisterEmployeePosition
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_EMPLOYEE_POSITION_URL, {
      ...registerEmployeePosition,
    });
    return response;
  };

  static editEmployeePosition = async (editEmployeePosition: EditEmployeePosition): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_EMPLOYEE_POSITION_URL, {
      ...editEmployeePosition,
    });
    return response;
  };

  static toggleEmployeePositionIsActive = async (
    editEmployeePosition: EditEmployeePosition
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_EMPLOYEE_POSITION_IS_ACTIVE_URL,
      {
        ...editEmployeePosition,
      }
    );
    return response;
  };

  static getUnassignedEmployees = async (params: { organizationId?: string }): Promise<AxiosResponse> =>
    baseAPI.get(GET_UNASSIGNED_EMPLOYEES_URL, { params });

  static deleteEmployeePosition = async (userId: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_EMPLOYEE_POSITION_URL}/${userId}`
    );
    return response;
  };
}

export default EmployeePosition;
